// Icons exported from the Figma tech-stories frames (CTA triangle + pause glyph).
// Drawn with currentColor so the same glyph works on the dark (mobile) and light (desktop) themes.

export function StoryPlayIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.8453"
      height="12.799"
      viewBox="0 0 10.8453 12.799"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path
        d="M4.91707e-06 1.52743C5.53202e-06 0.308739 1.35892 -0.417529 2.37216 0.259636L10.1677 5.46952C11.1053 6.09611 11.0619 7.4884 10.0871 8.05541L2.29157 12.5899C1.275 13.1813 -5.93433e-07 12.4479 0 11.2718L4.91707e-06 1.52743Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function StoryPauseIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9.64592"
      height="11.0239"
      viewBox="0 0 9.64592 11.0239"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path
        d="M1.37799 0V11.0239M8.26793 0V11.0239"
        stroke="currentColor"
        strokeWidth="2.75598"
      />
    </svg>
  );
}
